import * as React from 'react';
import * as cx from 'classnames';
import Typography from '@material-ui/core/Typography';
import { WithStyles, withStyles, createStyles } from '@material-ui/core/styles';

import { withIntl, IntlProps } from 'ha/i18n';
import MediaQuery from 'ha/helpers/MediaQuery';
import Link from 'ha/ui/next/Link';

interface Props {
  placeName: string;
  advertiserName: string;
  params: {
    location: string;
  };
}

const styles = createStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  containerMobile: {
    lineHeight: 3,
  },
});

export const SearchAdvertiserTitle: React.SFC<
  Props & IntlProps & WithStyles<typeof styles>
> = ({
  classes,
  advertiserName,
  placeName,
  intl: { T, urlResolver },
  params: { location },
}) => (
  <MediaQuery>
    {({ lg }) => (
      <div
        className={cx({
          [classes.container]: lg,
          [classes.containerMobile]: !lg,
        })}
      >
        <Typography component="h1" variant="subheading">
          {T('search_advertiser_title', advertiserName, placeName)}
        </Typography>
        <Link
          to={urlResolver.absolutizePath(`/s/${location}`)}
          kind="mint-underline"
        >
          {T('See all listings in %s', placeName)}
        </Link>
      </div>
    )}
  </MediaQuery>
);

export default withIntl(withStyles(styles)(SearchAdvertiserTitle));
